let navInteractionStartTime = null;
export const setNavInteractionStartTime = () => {
  navInteractionStartTime = performance.now();
};
export const clearNavInteractionStartTime = () => {
  navInteractionStartTime = null;
};
export const getNavInteractionStartTime = () => {
  return navInteractionStartTime;
};